import { render, staticRenderFns } from "./SharePinterest.vue?vue&type=template&id=26829a96&scoped=true&"
import script from "./SharePinterest.vue?vue&type=script&lang=js&"
export * from "./SharePinterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26829a96",
  null
  
)

export default component.exports